/* eslint-disable no-unused-vars */
function changeValue(value2) {
  if (value2 == 0) {
    bilgiler();
  }
  if (value2 == 1) {
    ekbilgiler();
  }

}



function bilgiler() {
  $("#divBilgiler").attr('style', 'display:block');
  $("#divEkBilgiler").attr('style', 'display:none');
}

function ekbilgiler() {
  $("#divEkBilgiler").attr('style', 'display:block');
  $("#divBilgiler").attr('style', 'display:none');
}
